import { Component, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Mission } from 'src/app/shared/models/mission';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { Constant } from 'src/app/shared/service/utils/contant';
import { RecommandationComponent } from '../recommandation/recommandation.component';

@Component({
  selector: 'app-mission',
  standalone: false,
  templateUrl: './mission.component.html',
  styleUrl: './mission.component.scss'
})

export class MissionComponent {

  // breadcrumb items
  breadCrumbItems: Array<{}>;

  submitted: boolean;
  filteredData: any[] = []; // Données filtrées
  searchTerm: string = ''; // Terme de recherche
  missionItems: any = [];
  modalRef: NgbModalRef | null = null;
  paginatedItems: any[] = [];
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0; // Nombre total d'éléments
  isLoading: boolean = false;
  item: Mission = new Mission()
  itemToDelete!: any;
  @ViewChild('missionModal') modalContent!: TemplateRef<any>;
  @ViewChild('editModalMission') modalContent1!: TemplateRef<any>;

  typemissionItems: any[] = [];
  serviceItems: any[] = [];
  dateDebut:any;
  dateFin:any;
  selectedMission:any;
  constructor(
    private modalService: NgbModal,

    public formBuilder: UntypedFormBuilder,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private ngxService: NgxUiLoaderService,
    private router: Router
  ) {

    // this.projetService.projetCreated$.subscribe(() => {
    //   this.fetchDataAction();
    // });
  }

  ngOnInit(): void {
    this.getMission();
    this.getTypeMission();
  }

  //liste des missions
  getMission() {
    this.isLoading = true;
    this.paramservice.getAllMission().subscribe(
      (response: any) => {
        this.isLoading = false;
        this.missionItems = response.data;
        this.filteredData = [...this.missionItems]; // Initialiser filteredData avec toutes les données
        this.totalRecords = this.filteredData.length;
        this.updatePagination();
        ////console.log("this.actionData", this.revuBudgetaire);
      },
      (error) => {
        ////console.log("une erreur est survenu", error);
      }
    );
  }


  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.updatePagination();
  }


  updatePagination() {
    const start = this.first;
    const end = this.first + this.rows;
    this.paginatedItems = this.filteredData.slice(start, end);

    ////console.log("this.updateRessourceStats",this.paginatedItems);
  }


  applyGlobalFilter() {
  this.filteredData = this.missionItems.filter((item: any) => {

    const itemDateDebut = new Date(item.date_debut);
    const itemDateFin = new Date(item.date_fin);

    //  Filtre date début
    const matchDateDebut = this.dateDebut
      ? itemDateDebut >= new Date(this.dateDebut)
      : true;

    //  Filtre date fin
    const matchDateFin = this.dateFin
      ? itemDateFin <= new Date(this.dateFin)
      : true;

    //  Filtre type mission
    const matchMission = this.selectedMission
      ? item.type_mission?.id == this.selectedMission
      : true;

    return matchDateDebut && matchDateFin && matchMission;
  });

  // Mettre à jour pagination
  this.totalRecords = this.filteredData.length;
  this.first = 0;
  this.updatePagination();
}
  applyFilter(term: string) {
    this.searchTerm = term.trim().toLowerCase();

    if (this.searchTerm) {
      this.filteredData = this.missionItems.filter(item =>
        item.libelle.toLowerCase().includes(this.searchTerm)
      );
    } else {
      // Réinitialiser les données filtrées si la recherche est vide
      this.filteredData = [...this.missionItems];
    }

    this.totalRecords = this.filteredData.length;
    this.first = 0; // Revenir à la première page après le filtrage
    this.updatePagination();
  }




  addProjetToActiviter(item: any) {

    ////console.log("item");

    this.localstorage.saveProjetActivite(item);

    this.router.navigate(['/suivi/planification/projet-activite'])
  }



  openModal() {

    this.item = new Mission();
    this.modalService.open(this.modalContent, {
      size: 'xl',
      backdrop: 'static',
      keyboard: false
    });
  }

  Recommandation(item: any) {

    this.localstorage.saveRecommandation(item)
    const modalRef = this.modalService.open(RecommandationComponent, {
      backdrop: 'static',
      centered: true,
      size: "xl"
    },);
  }

  refMission: any;
  editModal(item: any) {
    this.item.libelle = item.libelle;
    this.item.type_mission_id = item.type_mission_id;
    const date = new Date(item.date_debut);
    const formatted = date.toISOString().split('T')[0]; // Format: 'YYYY-MM-DD'
    this.item.date_debut = formatted;
    const dateFin = new Date(item.date_fin);
    const formattedFin = dateFin.toISOString().split('T')[0]; // Format: 'YYYY-MM-DD'
    this.item.date_fin = formattedFin;
    this.item.objet = item.objet;
    this.item.mission_id = item.reference;
    this.modalService.open(this.modalContent1, {
      size: 'xl',
      backdrop: 'static',
      keyboard: false
    });
  }
  close() {
    this.modalService.dismissAll()
  }

  addMission() {
    //check
    if (!this.item.canSave()) {
      this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: this.item.getErrorMessage() });
      return;
    }

    //
    this.ngxService.start();
    this.paramservice.addMission(this.item).subscribe(
      (response: any) => {
        this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
        this.ngxService.stop();
        this.getMission();
        this.modalService.dismissAll();
        ////console.log("this.actionData", this.revuBudgetaire);
      },
      (error: any) => {
        this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: error.error.message });
        this.ngxService.stop()

        ////console.log("une erreur est survenu", error);
      }
    );
  }


  //mise a jour e mission
  updateMission() {

    //check
    if (!this.item.canSave()) {
      this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: this.item.getErrorMessage() });
      return;
    }

    //
    this.ngxService.start();
    this.paramservice.updateMission(this.item, this.item.mission_id).subscribe(
      (response: any) => {
        this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
        this.ngxService.stop();
        this.getMission();
        this.modalService.dismissAll();
        ////console.log("this.actionData", this.revuBudgetaire);
      },
      (error: any) => {
        this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: error.error.message });
        this.ngxService.stop()

        ////console.log("une erreur est survenu", error);
      }
    );
  }
  getTypeMission() {
    this.paramservice.getTypeMission().subscribe(
      (response: any) => {
        this.typemissionItems = response.data
        //console.log("this.typemissionItems", this.typemissionItems);
      },
      (error) => {
        ////console.log("une erreur est survenu", error);
      }
    );
  }
  // getMission(item: any) {
  //   let requestData = {
  //     type_id: item
  //   }
  //   this.paramservice.getMission(requestData).subscribe(
  //     (response: any) => {
  //       this.missionItems = response.data
  //       this.getService();
  //       ////console.log("this.actionData", this.revuBudgetaire);
  //     },
  //     (error) => {
  //       ////console.log("une erreur est survenu", error);
  //     }
  //   );

  // }

  getService() {

    this.paramservice.fetchDataService().subscribe(
      (response: any) => {
        this.serviceItems = response.data
        ////console.log("this.actionData", this.revuBudgetaire);
      },
      (error) => {
        ////console.log("une erreur est survenu", error);
      }
    );
  }


  //confirme la suppression
  confirmDeletion(item: any) {
    this.confirmationService.confirm({
      message: 'Êtes-vous sûr de vouloir supprimer cette mission ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.ngxService.start();
        this.paramservice.deleteCommission(item.reference).subscribe(

          (response: any) => {
            this.ngxService.stop();
            ////console.log("la reponse du webserice",response);
            this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
            this.getMission();
          },
          (error) => {
            ////console.log("une erreur est survenu",error);
            this.ngxService.stop();
            this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: error });

          },
        )
      },
      reject: () => {
        //this.messageService.add({ severity: 'error', summary: 'X-Project', detail: 'Vous avez rejeté', life: 3000 });
      }
    });
  }//end confirmDelet
}